import { HttpClient } from '@angular/common/http';

import { ConfigService } from '@finder/core/config.service';
import { LiveCommerceCustomError } from '@finder/shared/features/live-commerce/live-commerce.interface';
import { CONFIG_CONSTANTS } from '@finder/shared/constants/app.constants';
import { Observable } from 'rxjs/Observable';
import {
    SfccCartAddProduct,
    SfccCartCreateWithProduct,
    SfccCartRemoveProduct,
    SfccCartUpdateProduct
} from './sfcc.interface';

export abstract class SfccConnector {
    constructor(
        protected config: ConfigService,
        protected http: HttpClient,
    ) {}

    login(): Observable<any> {
        const apiBase = this.getApiBase();
        const url = `${apiBase}/shop/login`;

        return this.http.post(url, {}) as Observable<any>;
    }

    getProductDataBySku(skus: string[]): Observable<any> {
        const apiBase = this.getApiBase();
        const url = `${apiBase}/shop/product/${skus.join(',')}`;
        return this.http.get(url) as Observable<any>;
    }

    abstract auth();

    abstract addProducts(skus: string[]);

    abstract addProduct(product: SfccCartAddProduct);

    abstract updateProduct(product: SfccCartUpdateProduct);

    abstract removeProduct(product: SfccCartRemoveProduct);

    abstract createCartWithProduct(product: SfccCartCreateWithProduct);

    getApiBase() {
        const baseUrl = this.config.getValue(CONFIG_CONSTANTS.apiUrlKey);
        const version = this.config.getValue(CONFIG_CONSTANTS.defaultVersionKey);
        return `${baseUrl}/${version}`;
    }
}
